const padding = { none: '', sm: 'p-3', md: 'p-5', lg: 'p-6' };

const Card = ({ children, interactive = false, padding: p = 'md', className = '', onClick, ...props }) => (
  <div
    className={`bg-white rounded-xl border border-gray-100 shadow-card ${interactive ? 'hover:shadow-card-hover hover:-translate-y-0.5 transition-all duration-300 cursor-pointer' : ''} ${padding[p] || padding.md} ${className}`}
    onClick={onClick} {...props}
  >{children}</div>
);

Card.Header = ({ children, className = '' }) => <div className={`mb-4 ${className}`}>{children}</div>;
Card.Title = ({ children, className = '' }) => <h3 className={`text-lg font-semibold text-gray-900 ${className}`}>{children}</h3>;
Card.Description = ({ children, className = '' }) => <p className={`text-sm text-gray-500 mt-1 ${className}`}>{children}</p>;
Card.Content = ({ children, className = '' }) => <div className={className}>{children}</div>;
Card.Footer = ({ children, className = '' }) => <div className={`mt-4 pt-4 border-t border-gray-100 ${className}`}>{children}</div>;

export default Card;
